import { http, HttpResponse } from 'msw';

import { LeagueType } from '~/server/src/dtos';

import { users } from './apiMockData';

const createRankUsers = (toplistLeague: LeagueType) =>
  users
    .filter((user) => user.toplistLeague === toplistLeague)
    .sort((a, b) => a.toplistRank - b.toplistRank);

const toplistHandlers = [
  http.get('*/toplistBronze', () => {
    const rankedUsers = createRankUsers(LeagueType.Bronze);
    return HttpResponse.json(rankedUsers);
  }),

  http.get('*/toplistSilver', () => {
    const rankedUsers = createRankUsers(LeagueType.Silver);
    return HttpResponse.json(rankedUsers);
  }),

  http.get('*/toplistGold', () => {
    const rankedUsers = createRankUsers(LeagueType.Gold);
    return HttpResponse.json(rankedUsers);
  }),

  http.get('*/toplistGlobal', () => {
    return HttpResponse.json({ items: [], total: 0, page: 0, pageSize: 50 });
  }),
];

export default toplistHandlers;
